module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "lte-tag",
    class: _vm.classArr,
    style: ({
      'background-color': _vm.bgColor + '!important'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d33a0f06","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tag/tag.vue
// module id = 50
// module chunks = 0